import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://example.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.example'

// 检查是否是占位符配置
const isPlaceholderConfig = supabaseUrl === 'https://example.supabase.co' || supabaseAnonKey === 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.example'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// 数据库表类型定义
export interface Article {
  id: number
  title: string
  author: string
  date: string
  summary: string
  content: string
  cover_image?: string
  created_at?: string
}

// 文章列表项类型（不包含完整内容）
export interface ArticleListItem {
  id: number
  title: string
  author: string
  date: string
  summary: string
  cover_image?: string
}

export interface User {
  id: string;
  username: string;
  created_at?: string;
  avatar_url?: string;
}

// 导出配置检查函数
export const checkSupabaseConfig = () => {
  if (isPlaceholderConfig) {
    console.warn('⚠️ Supabase 配置未设置，请创建 .env 文件并配置正确的 Supabase URL 和密钥')
    return false
  }
  return true
} 